import React, { CSSProperties } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SpacerVertical, Typography } from '@klarna/bubble-ui';
import { translator } from 'mage-i18n';
import { getMerchantAwareArrayTranslator } from '@/selectors/merchant';

interface ReviewStepsProps {
  t: TranslatorFunction;
  tArrayMerchantAware: TranslatorFunction;
}

const ReviewSteps = ({ t, tArrayMerchantAware }: ReviewStepsProps): React.JSX.Element => {
  const tPrefix = 'products-fe.containers.merchant_verification_overview';

  const styles = {
    verificationInfoWrapper: {
      display: 'flex',
      flexDirection: 'column' as CSSProperties['flexDirection'],
    },
  };

  return (
    <>
      <SpacerVertical spaceToken="space/400" />
      <Typography textToken="text-style/headings/titles/bold/secondary">
        {t(`${tPrefix}.info_title`)}
      </Typography>
      <SpacerVertical spaceToken="space/400" />
      <div style={styles.verificationInfoWrapper}>
        <Typography textToken="text-style/text/labels/grande/bold">
          {t(`${tPrefix}.infos.review.title`)}
        </Typography>
        <SpacerVertical spaceToken="space/100" />
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {t(`${tPrefix}.infos.review.description`)}
        </Typography>

        <SpacerVertical spaceToken="space/400" />

        <Typography textToken="text-style/text/labels/grande/bold">
          {t(`${tPrefix}.infos.info.title`)}
        </Typography>
        <SpacerVertical spaceToken="space/100" />
        <Typography textToken="text-style/text/super-paragraphs/body/regular">
          {t(`${tPrefix}.infos.info.description`)}
        </Typography>
        {((tArrayMerchantAware(`${tPrefix}.infos.info.list`) as unknown) as Array<
          Record<string, string>
        >).map(({ text }, index) => (
          <li style={{ paddingLeft: '1em' }} key={`info-${index}`}>
            <Typography
              textToken="text-style/text/super-paragraphs/body/regular"
              key={`review-steps-list-${index}`}
            >
              {text}
            </Typography>
            <SpacerVertical spaceToken="space/100" />
          </li>
        ))}
      </div>
    </>
  );
};

ReviewSteps.propTypes = {
  t: PropTypes.func.isRequired,
  tArrayMerchantAware: PropTypes.func.isRequired,
};

export default connect(state => ({
  t: translator(state),
  tArrayMerchantAware: getMerchantAwareArrayTranslator(state),
}))(ReviewSteps);
